<template>
  <div>
    <CRow class="w-100">
      <CCol md="12" lg="12" sm="12" xs="12">
        <ProccessDemoVue v-if="page == 'proccess' && $store.getters.get_company.id == 1" @changePage="changePage" @setView="setView" />
        <PurchaseVue class="pt-1" v-if="page == 'purchase'" @returnHome="returnHome" />
        <SaleVue class="pt-1" v-if="page == 'sale' && $store.getters.get_company.id == 1" @returnHome="returnHome" />
        <StockVue class="pt-1" v-if="page == 'stock'" @returnHome="returnHome" />
        <MovementStockVue class="pt-1" v-if="page == 'mov_stock' && ($store.getters.get_campu.id == 1 || $store.getters.get_campu.id == 3)" @returnHome="returnHome" />
        <ExitNoteVue class="pt-1" v-if="page == 'exit_note' " @returnHome="returnHome" />
        <KardexVue class="pt-1" v-if="page == 'kardex'" @returnHome="returnHome" />
        <CxcVue class="pt-1" v-if="page == 'cxc'" @returnHome="returnHome" :bead="bead"/>
        <CancelVoucher class="pt-1" v-if="page == 'cancel_voucher'" @returnHome="returnHome" />
        <ListProducts class="pt-1" v-if="page == 'list_products'" @returnHome="returnHome" />
        <PaymentComand class="pt-1" v-if="page == 'comand'" @returnHome="returnHome" />
      </CCol>
    </CRow>
  </div>
</template>

<script>

import ProccessDemoVue from '../../components/proccess/demo/Home.vue';
import PurchaseVue from '../../components/proccess/aq/purchase/page/Purchase.vue';
import SaleVue from '../../components/proccess/demo/sale/page/Sale.vue';
import StockVue from '../../components/proccess/demo/stock/page/Stock.vue';
import KardexVue from '../../components/proccess/demo/kardex/page/Kardex.vue';
import MovementStockVue from '../../components/proccess/aq/movementstock/page/MovementStock.vue';
import CxcVue from '../../components/proccess/demo/cxcs/page/Cxv.vue';
import CancelVoucher from '../../components/proccess/demo/CancelVocuher/Cancel.vue';
import ExitNoteVue from '../../components/proccess/aq/exitnote/page/ExitNote.vue';
/**  */
import ListProducts from '../../components/proccess/aq/ListProducts/ListProducst.vue'
import PaymentComand from '../../components/proccess/demo/Comand/Payment.vue';
import { mapActions } from "vuex";

export default {
  components: {
    PurchaseVue,
    SaleVue,
    ProccessDemoVue,
    StockVue,
    KardexVue,
    MovementStockVue,
    CxcVue,
    CancelVoucher,
    ExitNoteVue,
    ListProducts,
    PaymentComand
  },
  data() {
    return {
      page: 'proccess',
      bead: {},
    }
  },
  created() {
      this.mtdDataBead();
  },
  methods: {
    ...mapActions(["get", "post"]),

    changePage(page) {
      this.page = page;
      this.$emit("mtdViewFooter", false, 'proccess');
    },
    returnHome() {
      this.page = 'proccess';
      this.$emit("mtdViewFooter", true, 'proccess');
    },
    mtdBack: function () {
      this.page = 'proccess';
      this.$emit("mtdViewFooter", true, 'proccess');
      // this.$emit('setView', 'home')
    },
    setView: function () {
      this.$emit('setView', 'home')
    },

    mtdDataBead() {
        this.get({
            url: this.$store.getters.get__url +
                "/cxc/listBeads/" +
                this.$store.getters.get_campu.id + "/" +
                this.$store.getters.get_company.id,
            token: this.$store.getters.get__token,
        })
        .then((response) => {
            this.bead = response.data.bead;
        })
        .catch((errors) => {
            console.log(errors);
        });
    },


  }
};
</script>
